export const SECONDS = {
  SECOND: 0,
  DAY: 24 * 60 * 60,
  WEEK: 7 * 24 * 60 * 60,
  TWO_WEEKS: 2 * 7 * 24 * 60 * 60,
} as const;
